import React, { useState, useEffect, useContext } from "react";
import { Client, Hub, KeyValue } from "../../common/models";
import orgDataService from "services/orgDataService";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
  Paper,
  Grid,
  Checkbox,
  FormControlLabel,
  TextField,
} from "@mui/material";
import moment from "moment";
import { DateTimePicker } from "@mui/x-date-pickers";
import MDButton from "components/MDButton";
import { Role } from "common/Constants";
import { AuthContext } from "common/AuthProvider";
import MultiSelect from "common/components/MultiSelect";

const ListFilter = ({ search, setSearch, gridRef, clearFilters }) => {
  const { isUserInRole } = useContext(AuthContext);
  let isDispatcher: boolean = isUserInRole(Role.Dispatcher);
  const [hubs, setHubs] = useState<Hub[]>([]);
  const [clients, setClients] = useState<Client[]>([]);
  const [orderStatuses, setOrderStatuses] = useState<KeyValue[]>([]);
  const [types, setTypes] = useState([
    { id: 1, name: "Barge", value: "barge" },
    { id: 2, name: "RailRoad", value: "standard" },
  ]);
  useEffect(() => {
    orgDataService.getAllHubs().then((data) => setHubs(data));
    orgDataService.getAllClients().then((data) => setClients(data));
    orgDataService.getOrderStatuses().then((data) => setOrderStatuses(data));
  }, []);

  function handleOnChange(e: any) {
    var request = { ...search, [e.target.name]: e.target.value };
    setSearch(request);
    gridRef.current.setPage(0);
  }

  return (
    <>
      <Grid container>
       
          <TextField
            sx={{ mt: 2, ml: 1 }}
            name="name"
            label="Name"
            value={search.name || ""}
            onChange={handleOnChange}
          />
          <MultiSelect
            label={"Hub"}
            values={hubs}
            selectedValues={search.hubIds}
            setSelectedValues={(values) => setSearch({ ...search, hubIds: values })}
          />
          <MultiSelect
            label={"Client"}
            values={clients}
            selectedValues={search.clientIds}
            setSelectedValues={(values) => setSearch({ ...search, clientIds: values })}
          />

          {/*
            Active / Inactive / All. Sits next to Client and defaults to Active, so a deactivated
            location is out of the way unless it is being looked for -- a deactivated point used to
            appear in this list identical to a working one, which is how "it is in the list but it
            does not work" happened.

            The value is a tri-state on the wire: true, false, or absent for All. It is carried
            through the select as a string because a MUI Select cannot hold undefined as a value
            without going uncontrolled.
          */}
          <FormControl sx={{ mt: 2, ml: 1, minWidth: 140 }}>
            <InputLabel id="points-active-label">Status</InputLabel>
            <Select
              labelId="points-active-label"
              label="Status"
              value={search.isActive === undefined ? "all" : search.isActive ? "active" : "inactive"}
              onChange={(e: any) => {
                const picked = e.target.value;
                setSearch({
                  ...search,
                  isActive: picked === "all" ? undefined : picked === "active",
                  pagedSearchOptions: { ...search.pagedSearchOptions, offset: 0 },
                });
                gridRef.current?.setPage?.(0);
              }}
            >
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="inactive">Inactive</MenuItem>
              <MenuItem value="all">All</MenuItem>
            </Select>
          </FormControl>

          <MDButton sx={{ mt: 2, ml: 1 }} onClick={clearFilters}>
            Clear
          </MDButton>
        
      </Grid>
    </>
  );
};
export default ListFilter;
